
import React, { useState } from 'react';
import { motion } from 'framer-motion';


import barsIcon from './images/images-rentApp/bars-icon.svg'
import gridIcon from './images/images-rentApp/gridIcon.svg'
import listIcon from './images/images-rentApp/list-icon.svg'
import filterIcon from './images/images-rentApp/filter-icon.svg'
import searchIcon from './images/images-rentApp/search-icon.svg'
import downArrow from './images/images-rentApp/downArrow.svg'
import checkIcon from './images/images-rentApp/check-icon.svg'
import plusIcon from './images/images-rentApp/plus-icon.svg'
import locationIcon from './images/images-rentApp/location.svg'
import trashIcon from './images/images-rentApp/trash-icon.svg'
import heartIcon from './images/images-rentApp/heart-icon.svg'

    const  FavedPopup = React.forwardRef ((props, ref) => {
        
        const [FavedOffers, setFavedOffers] = useState(props.FavOffers.list)


        function FavCard({ favOffer, link, index }) {

            function deleteOffer(indexToDel) {
                    const updatedOffers = [...FavedOffers];
                    updatedOffers.splice(indexToDel, 1);
                    setFavedOffers(updatedOffers)
            }
            
            return (
                <div className='favCard'>
                    <h4 style={{ width: '100%'}}>
                        <div><img src={locationIcon} alt="Location-Icon" />{favOffer.location}</div>
                        <img src={trashIcon} alt="remove-Icon" style={{cursor: 'pointer'}} onClick={() =>  deleteOffer(index)}/>
                    </h4>
                    <div className='pillsContainer' style={{ gap: '5px'}}>

                            <div className='propPill' id='purplePills'>{favOffer.type}</div>
                    </div>

                    <div style={{display: 'flex', 'justify-content': 'space-between', 'align-items': 'center'}}>
                        <div>
                            <div style={{ fontSize: '12px', fontWeight: '800', width: '100%' }}>Offers</div>
                            <div style={{ fontSize: '12px', fontWeight: '400', width: '100%' }}>{favOffer.date}</div>
                        </div>
                        <div className='myButton' style={{transform: 'translateX(7px)', width: '11px'}}><img src={searchIcon} style={{transform: 'translateX(-5px)'}}/></div>
                    </div>

                </div>
            );
        }
        

        const variants = {
            visible: { opacity: 1, transition: { duration: 0.2 } },
            hidden: { opacity: 0, transition: { duration: 0.3 } },
            };

        return( 

            <motion.div className='FavedMain' ref={ref} initial="hidden" animate={'visible'} variants={variants}>
                <div className='FavedContainer' >
                    <button class="closeButton" onClick={(() => props.setFavedPop(false))}>&times;</button>

                        <div className='popUpHeader'>Saved Offers</div>
                        <div className='cardsCont'>
                                {FavedOffers.map((favOffer, index) => (
                                    index < 3 ? ( <FavCard favOffer= {favOffer} link = 'Lamgem Link' index={index}/>
                                    
                                    ): null
                                    ))}
                                
                                {FavedOffers.length === 0 ? (<div style={{display: 'flex', 'flex-direction': 'column', 'align-items': 'center', 'justify-content': 'center', gap: '23px' ,'font-weight': '800', opacity: '.2'}}><img style={{width: '53px'}}src={heartIcon}/>Your list is empty</div>) : null}

                        </div>
                    <div className='popUpFooter' style={{ display: 'flex', 'justify-content' : 'center'}}>
                        
                        <div className='myButton' style={{'border-radius': '11px', width: '85%', display: 'flex', 'justify-content' : 'center'}}>Show all</div>
                        
                        </div>
                </div>
            </motion.div>
        
        )
        
    })

    export default FavedPopup;

